import axios from 'axios';

export default axios.create({
    baseURL: 'https://pxr8nz5d10.execute-api.us-east-1.amazonaws.com/v1'
});